import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { push } from 'connected-react-router';
import { NEXT } from '../../../hooks/useStepNavigations';
import AlgorithmCard from '../acquisition/AlgorithmCard';
import shorelinesThumb from '../../../resources/shorelinesThumb.jpg';
import { MODULE_COLORS } from '../../../common/moduleTheme';
import { CHOICE_GRID_MAX_WIDTH } from '../../../theme';

const DOCS_URL = 'https://github.com/hcordeiroAtLoc/shoreline-s-wrapper';

const useStyles = makeStyles((theme) => ({
  grid: {
    margin: '0 auto',
    width: '100%',
    maxWidth: CHOICE_GRID_MAX_WIDTH,
    padding: theme.spacing(2),
  },
  button: {
    marginBottom: theme.spacing(4),
  },
}));

/**
 * @function ShoreSEntryChooser
 * @description Shore-S's landing step: presents the module card (advances to the acquisition
 * flow) and a docs card (opens the ShorelineS wrapper's external documentation), plus a button
 * back to the module selection page.
 * @param {Object} props - Component props.
 * @param {Function} props.navigate - Function to navigate between steps.
 * **Called by:
 * @see {ShoresSAcquisitionPage}
 * @memberof module:ShoreS
 * @returns {JSX.Element} The ShoreSEntryChooser component.
 */
const ShoreSEntryChooser = ({ navigate }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <Box>
      <Grid container spacing={3} justifyContent="center" className={classes.grid}>
        <Grid item xs={5}>
          <AlgorithmCard
            name={t('forms.shoreS.acquisition.entry.moduleCard')}
            color={MODULE_COLORS.shore_s}
            image={shorelinesThumb}
            description={t('forms.shoreS.acquisition.entry.moduleCardDesc')}
            onChoose={() => navigate(NEXT)}
            enabled
          />
        </Grid>
        <Grid item xs={5}>
          <AlgorithmCard
            name={t('forms.shoreS.acquisition.entry.docsCard')}
            color={MODULE_COLORS.shore_s}
            image={shorelinesThumb}
            description={t('forms.shoreS.acquisition.entry.docsCardDesc')}
            onChoose={() => window.open(DOCS_URL, '_blank')}
            enabled
          />
        </Grid>
      </Grid>
      <Box textAlign="center">
        <Button
          variant="contained"
          onClick={() => dispatch(push('/main/selection'))}
          className={classes.button}
        >
          {t('forms.acquisition.prev')}
        </Button>
      </Box>
    </Box>
  );
};

export default ShoreSEntryChooser;
